import moment from 'moment';
import { statusByName, typeByName } from './Filters';

export const initialState = {
  ordered: {
    chats: [],
    chatsNoEnded: [],
    chatsCount: [],
  },
  activeChat: '',
  infoChat: false,
  // improve firestore cache when navigating between views
  // because if startOfToday is the same value the query won't change
  startOfToday: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(),
  last24Hours: moment().subtract(1, 'day').toDate(),
  activeChatShowChatsNoEnded: false,
  filter: {
    local: {
      status: [0, 1, 2],
      type: -1,
      botStopped: -1,
      training: -1,
    },
    query: {
      keyword: '',
      date: null,
    },
  },
  countChats: {
    byStatus: {
      [statusByName['por hacer']]: 0,
      [statusByName.alta]: 0,
      [statusByName['en proceso']]: 0,
      [statusByName.terminado]: 0,
      [statusByName['en agenda']]: 0,
      [statusByName.practica]: 0,
      [statusByName.authorizations]: 0,
    },
    byType: {
      [typeByName.web]: 0,
      [typeByName.whatsapp]: 0,
    },
    botStopped: 0,
    myChats: 0,
  },
  labelsConfiguration: {},
  alert: { snackbarOpen: false },
  loading: { loading: false, priority: 1 },
  professionals: [],
  specialties: [],
  commonSpecialties: [],
  lastUpdate: null,
  openSection: {
    filter: true,
    header: true,
  },
  patientPopup: {
    open: false,
    initProcess: false,
    submit: false,
    message: '',
  },
  organization: {},
  templates: [],
  mySupportedChats: [],
  kpiDate: {},
  isSupportChatBotOpen: false,
  graphicsDescriptions: {},
};
